import {ChangeDetectorRef, Component, ElementRef, NgZone, OnInit, Renderer2, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ClientService} from '../../Services/client.service';
import {AuthService} from '../../auth/AuthService';
import {ActivatedRoute, Router} from '@angular/router';
import {debounceTime, first} from 'rxjs/operators';
import swal from 'sweetalert2';
import {Sort} from '@angular/material/sort';
import {QuestionsService} from '../../Services/questions.service';
import {Subject} from 'rxjs';

@Component({
    selector: 'pm-questions',
    templateUrl: './questions.component.html',
    styleUrls: ['./questions.component.css']
})
export class QuestionsComponent implements OnInit {


    tableData: any = [];
    phoneType: any = [
        {value: 'Mobile', viewValue: 'Mobile'},
        {value: 'Work', viewValue: 'Work'},
        {value: 'Home', viewValue: 'Home'},
    ];
    selectedCategory: any;
    selectedDomain: 'DENTAL' | 'MEDICAL' = 'DENTAL';
    private requestVersion = 0;
    categoryArray: any = [];
    searchText: any;
    isSidebarExpanded = false;
    hidePassword = true;
    hideNewPassword = true;
    hideConfirmPassword = true;
    private clientSub: any;
    private subject: Subject<string> = new Subject();
    searchString: any = null;
    @ViewChild('resetPassword') resetPassModal!: ElementRef;
    @ViewChild('searchBox') searchValue!: ElementRef;

    constructor(private fb: FormBuilder,
                private clientServices: ClientService,
                private questionService: QuestionsService,
                public authService: AuthService,
                private router: Router,
                private activatedRoute: ActivatedRoute,
                private renderer: Renderer2,
                private el: ElementRef,
                private cdr: ChangeDetectorRef,
                private ngZone: NgZone) {
        this.selectedDomain = this.activatedRoute.snapshot.queryParamMap.get('domain')?.toUpperCase() === 'MEDICAL' ? 'MEDICAL' : 'DENTAL';
        this._setSearchSubscription();
    }


    ngOnInit(): void {
        this.getCategoryDropdown();
        this.clientSub = this.authService.clientIdSubject.subscribe((clientId: number | null) => {
          if (clientId) { this.getCategoryDropdown(); }
        });
    }
    ngOnDestroy(): void {
      this.clientSub?.unsubscribe();
    }

    onKeyUp(searchTextValue: any): void {
        this.subject.next(searchTextValue);
    }

    private _setSearchSubscription(): void {
        this.subject.pipe(
            debounceTime(200)
        ).subscribe((searchValue: any) => {
            if (this.searchValue.nativeElement.value === '') {
                this.onSearch();
            }
        });
    }

    changeDomain(domain: 'DENTAL' | 'MEDICAL'): void {
        if (this.selectedDomain === domain) { return; }
        this.selectedDomain = domain;
        this.searchString = null;
        if (this.searchValue) { this.searchValue.nativeElement.value = ''; }
        this.tableData = [];
        this.categoryArray = [];
        this.selectedCategory = null;
        this.requestVersion++;
        this.router.navigate([], { relativeTo: this.activatedRoute, queryParams: { domain }, queryParamsHandling: 'merge', replaceUrl: true });
        this.getCategoryDropdown();
    }

    getCategoryDropdown() {
        const version = ++this.requestVersion;
        this.questionService.getCategoryDropdown({ domain: this.selectedDomain }).pipe(first()).subscribe(
            (response: any) => {
                if (version !== this.requestVersion) { return; }
                this.categoryArray = Array.isArray(response) ? response : [];
                this.selectedCategory = this.categoryArray.length ? this.categoryArray[0].category : null;
                if (this.selectedCategory) { this._fetchData(this.selectedCategory); }
                else { this.tableData = []; }
            });
    }
    changeCategory(category:any){
        this.selectedCategory = category?.value;
        this._fetchData(category?.value);
    }

    onSearch() {
        let inputValue = this.searchValue.nativeElement.value;
        if (inputValue !== '') {
            this.searchString = inputValue;
            this.searchQuestion(this.searchString);
        }else{
            this.searchString = '' || null;
            this._fetchData(this.selectedCategory)
        }
    }

    handleKeyUp(event: KeyboardEvent) {
      const value = (event.target as HTMLInputElement).value;

      // Trigger search on Enter
      if (event.key === 'Enter') {
        this.onSearch();
        return;
      }

      // Existing debounce logic
      this.subject.next(value);
    }
    clearSearch(input: HTMLInputElement) {
      input.value = '';
      /*this.searchString = '';*/
      /*this.pagination.currentPage = 0;
      this.pagination.page = 1;*/
      this._fetchData(this.selectedCategory);
    }
    // Get Client data
    _fetchData(category?: any) {
    if (!category) { this.tableData = []; return; }
    const version = ++this.requestVersion;
    const params = { category, domain: this.selectedDomain };

    this.questionService.getQuestionCategoryList(params).pipe(first()).subscribe(
      (response: any) => {
        this.ngZone.run(() => {
          if (version !== this.requestVersion) { return; }
          if (response && response.length > 0) {
            this.tableData = response;
          } else {
            this.tableData = [];
            this.cdr.detectChanges();

            swal.fire({
              title: 'Error!',
              icon: 'error',
              text: response?.message || 'No data found',
              showConfirmButton: false,
              timer: 5000
            });
          }

          setTimeout(() => {
            this.cdr.detectChanges();
          }, 0);
        });
      },
      (error) => {
        this.ngZone.run(() => {
          if (version !== this.requestVersion) { return; }
          this.tableData = [];
          this.cdr.detectChanges();

          swal.fire({
            title: 'Error!',
            icon: 'error',
            text: error?.error?.message || '',
            showConfirmButton: false,
            timer: 5000
          });
        });
      }
    );
  }
    searchQuestion(filter?: any) {
        let params = {
            filter : filter,
            domain: this.selectedDomain
        };
        const version = ++this.requestVersion;
        this.questionService.getQuestionCategoryList(params).pipe(first()).subscribe(
            (response: any) => {
                if (version !== this.requestVersion) { return; }
                if (response != undefined) {
                    this.tableData = response;
                } else {
                    swal.fire({
                        title: 'Error!',
                        icon: 'error',
                        text: response.message,
                        showConfirmButton: false,
                        timer: 5000
                    });
                }
            },
            (error) => {
                swal.fire({
                    title: 'Error!',
                    icon: 'error',
                    text: error.error.message,
                    showConfirmButton: false,
                    timer: 5000
                });
            }
        );


    }
    // Delete record
     deleteEntry(questionId: any, question:any) {
         let params = {
             questionId: questionId,
             domain: this.selectedDomain
         };
         swal.fire({
             title: 'Are you sure?',
             html: `You want to delete this <span style="background: greenyellow; color: black;">" ${question} "</span> ?`,
             icon: 'warning',
             iconColor: 'red',
             showCancelButton: true,
             confirmButtonText: 'Yes !'
         }).then((result) => {
             if (result.isConfirmed) {
                 this.questionService.deleteQuestion(params).pipe(first()).subscribe(
                     (response: any) => {
                         if (response) {
                             this._fetchData(this.selectedCategory);
                             swal.fire({
                                 icon: 'success',
                                 text: 'Record deleted successfully.',
                                 showConfirmButton: false,
                                 timer: 2000
                             });
                         } else {
                             swal.fire({
                                 title: 'Error!',
                                 icon: 'error',
                                 text: 'Something went wrong!',
                                 showConfirmButton: false,
                                 timer: 2000
                             });
                         }
                     },
                     (error) => {
                         swal.fire({
                             title: 'Error!',
                             icon: 'error',
                             text: 'Failed to communicate with the server!',
                             showConfirmButton: false,
                             timer: 2000
                         });
                     });
             }
         });
     }

    // Sort form frontend logic
    sortData(sort: Sort) {
        const data = this.tableData.slice();
        if (!sort.active || sort.direction === '') {
            this.tableData = data;
            return;
        }

        this.tableData = data.sort((a, b) => {
            const isAsc = sort.direction === 'asc';
            switch (sort.active) {
                case 'categoryName':
                    return compare(a.categoryName, b.categoryName, isAsc);
                case 'question':
                    return compare(a.question, b.question, isAsc);
                case 'questionCode':
                    return compare(a.questionCode, b.questionCode, isAsc);
                default:
                    return 0;
            }
        });
    }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
